export default __webpack_public_path__ + "9addeee74a9c4fd1408c3e1b37c064fc.png";